import { CaseState } from 'app/area/case/types-store';

export function changeCaseSequence(caseState: CaseState, uiEngineProps: any) {
  const connectionSequenceCaseId = Number(Object.keys(caseState.stateForCaseIds || {})
    .find(key => caseState.stateForCaseIds?.[key]?.changeConnectionSequence?.fetching));
  const fetchingChangeConnectionSequence =
    caseState.stateForCaseIds?.[connectionSequenceCaseId]?.changeConnectionSequence?.fetching;
  return {
    changeConnectionSequence: {
      caseId: connectionSequenceCaseId,
      fetching: fetchingChangeConnectionSequence
    }
  };
}
